import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useCustomerSubscription} from '../hooks/useCustomerSubscription.ts';
import {useCustomerSubscriptionsSelection} from '../hooks/useCustomerSubscriptionsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools.tsx';
import {CustomerSubscription} from '../types';

export const EditPage = () => {
    const {id: subscriptionId} = useParams();

    if (typeof subscriptionId === 'undefined') {
        throw new Error('subscriptionId is required parameter');
    }

    const {
        record: subscription,
        loading,
        updateRecord,
    } = useCustomerSubscription(subscriptionId);

    const {handleClearSelection} = useCustomerSubscriptionsSelection();

    const [drawerOpened, setDrawerOpened] = useState(false);
    const {tools} = useEditPageTools({onEdit: () => setDrawerOpened(true)});

    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || !subscription) {
        return <PlatformLoader message='Loading subscription...Please wait'/>;
    }

    // Returns the save's outcome so the drawer closes only on success (§7).
    const handleDrawerSubmit = (values: CustomerSubscription) => updateRecord(values);

    return (
        <FormPageLayout
            title={subscription.id}
            pageNavigation={<EditPageNavigation component={subscription}/>}
            tools={tools}
        >
            <Stack gap='lg'>
                <Profile record={subscription}/>
            </Stack>

            <FormDrawer
                record={subscription}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </FormPageLayout>
    );
};
